import React from "react"

import VScroll from "../../../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"
import {DashboardTemplateConfig} from "../../../../../../core/gd-modules/dashboard/templates/templates-custom"
import {BreadcrumbElement} from "../../../../../../core/gd-components/breadcrumbs/breadcrumbs-custom"
import {QuickAddBreadcrumbElement} from "../../../../@types"
import QuickAdd_BreadcrumbNavigation from "../../../../layout/page-title/form-title-breadcrumb"
import Template from "../../../../../../core/model2/template/template";

type Props = {
    className?      : string

    parent          : any
    gdTemplate?     : DashboardTemplateConfig
    myTemplate?     : Template
    initParams      : any
}

export default function CustomDashboardWizard(props: Props) {
    console.log("CustomDashboardWizard", props)
    const breadcrumbItems: BreadcrumbElement[] = [
        QuickAddBreadcrumbElement.DASHBOARD,
        {
            label: "Dashboard setup"
        }
    ]

    return (
        <VScroll className="new-main dashboard new-form">
            <QuickAdd_BreadcrumbNavigation breadcrumbItems={breadcrumbItems}/>
            <div className="quick-add-content m-t-35">
                {props.gdTemplate &&
                    <props.gdTemplate.configComponent initParams={props.initParams}/>
                }
            </div>
        </VScroll>
    )

}
